import React from "react";
import { Button, Table, Card } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const AgenciesList = () => {
  const navigate = useNavigate();

  const handleAddNew = () => {
    navigate("/ats/agencies/new");
  };

  const columns = [
    { title: "Agency Name", dataIndex: "name", key: "name" },
    { title: "Contact Person", dataIndex: "contact", key: "contact" },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Phone", dataIndex: "phone", key: "phone" },
  ];

  const data = [
    { key: 1, name: "RecruitHub", contact: "Michael Brown", email: "michael@recruithub.com", phone: "+44 7788 112233" },
    { key: 2, name: "TalentFinders", contact: "Laura King", email: "laura@talentfinders.com", phone: "+971 55 7788990" },
  ];

  return (
    <Card
      title="Agencies"
      extra={
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAddNew}>
          Add New
        </Button>
      }
      styles={{ header: { flexWrap: "wrap", height: "auto", rowGap: 8 } }}
    >
      <Table
        columns={columns}
        dataSource={data}
        scroll={{ x: "max-content" }}
        pagination={{ pageSize: 10 }}
      />
    </Card>
  );
};

export default AgenciesList;
